module.exports = __webpack_public_path__ + "img/list-icon.ed03a74a.svg";